import { __decorate as t, __classPrivateFieldGet as e, __classPrivateFieldSet as s } from "tslib";
import { css as i, LitElement as o, html as r } from "lit";
import { property as l, state as n } from "lit/decorators.js";
var c, h, a, u, d, p, k, v;
class L extends o {
  constructor() {
    super(...arguments), c.set(this, 0), h.set(this, !1), a.set(this, !1), u.set(this, !1), d.set(this, !1), p.set(this, !1), k.set(this, !1), v.set(this, !1);
  }
  get colorpreset() {
    return e(this, c, "f");
  }
  set colorpreset(t) {
    s(this, c, t, "f");
  }
  get light() {
    return e(this, h, "f");
  }
  set light(t) {
    s(this, h, t, "f");
  }
  get active() {
    return e(this, a, "f");
  }
  set active(t) {
    s(this, a, t, "f");
  }
  get activeicon() {
    return e(this, u, "f");
  }
  set activeicon(t) {
    s(this, u, t, "f");
  }
  get block() {
    return e(this, d, "f");
  }
  set block(t) {
    s(this, d, t, "f");
  }
  get underlined() {
    return e(this, p, "f");
  }
  set underlined(t) {
    s(this, p, t, "f");
  }
  get isFocused() {
    return e(this, k, "f");
  }
  set isFocused(t) {
    s(this, k, t, "f");
  }
  get isHovered() {
    return e(this, v, "f");
  }
  set isHovered(t) {
    s(this, v, t, "f");
  }
  get currentLinkColor() {
    return window.getComputedStyle(this.link).color;
  }
  get linkColor() {
    return this.light ? "white" : this.colorpreset < 2 ? "var(--IDS-LINK--COLORPRESET-1__COLOR)" : 2 === this.colorpreset ? "var(--IDS-LINK--COLORPRESET-2__COLOR)" : 3 === this.colorpreset ? "var(--IDS-LINK--COLORPRESET-3__COLOR)" : this.currentLinkColor;
  }
  get linkHoverColor() {
    return this.light ? "white" : this.colorpreset < 2 ? "var(--IDS-LINK--COLORPRESET-1__HOVER-COLOR)" : 2 === this.colorpreset ? "var(--IDS-LINK--COLORPRESET-2__HOVER-COLOR)" : 3 === this.colorpreset ? "var(--IDS-LINK--COLORPRESET-3__HOVER-COLOR)" : this.currentLinkColor;
  }
  get link() {
    return this.querySelector("a");
  }
  get linkText() {
    return this.querySelector("a")?.textContent;
  }
  get icons() {
    return this.querySelectorAll(".ids-icon");
  }
  disconnectedCallback() {
    this.removeEventListener("mouseenter", this.setFocusTrue), this.removeEventListener("mouseleave", this.setFocusFalse), super.disconnectedCallback();
  }
  firstUpdated(t) {
    super.firstUpdated(t), this.updateLinkClasses(), this.icons.length > 0 && (this.setupIconsAttributes(), this.setupLinkEvents());
  }
  updated(t) {
    super.updated(t), this.updateLinkClasses();
  }
  setupLinkEvents() {
    this.link.addEventListener("mouseenter", this.setHoverTrue.bind(this)), this.link.addEventListener("mouseleave", this.setHoverFalse.bind(this)), this.link.addEventListener("focus", this.setFocusTrue.bind(this)), this.link.addEventListener("blur", this.setFocusFalse.bind(this));
  }
  setupIconsAttributes() {
    this.colorizeIcons(), this.icons.forEach(t => {
      this.setIconDefaultDimensions(t);
    });
  }
  setIconDefaultDimensions(t) {
    const e = t.tagName.toLowerCase().includes("arrow") ? "0.625rem" : "1rem",
      s = t;
    s.width || s.height || (t.setAttribute("width", e), t.setAttribute("height", e));
  }
  setIconColor(t) {
    t.getAttribute("color") || t.setAttribute("color", this.currentLinkColor), t.getAttribute("color2") || t.setAttribute("color2", this.currentLinkColor);
  }
  colorizeIcons() {
    this.icons.forEach((t, e) => {
      t && (this.activeicon && this.active && 0 === e || this.light || this.activeicon && 0 === e && (this.isFocused || this.isHovered) ? (t.setAttribute("color", "white"), t.setAttribute("color2", "white")) : this.isFocused || this.isHovered ? (t.setAttribute("color", this.linkHoverColor), t.setAttribute("color2", this.linkHoverColor)) : (t.setAttribute("color", this.linkColor), t.setAttribute("color2", this.linkColor)));
    });
  }
  setHoverTrue() {
    this.isHovered = !0, this.colorizeIcons();
  }
  setHoverFalse() {
    this.isHovered = !1, this.colorizeIcons();
  }
  setFocusTrue() {
    this.isFocused = !0, this.colorizeIcons();
  }
  setFocusFalse() {
    this.isFocused = !1, this.colorizeIcons();
  }
  updateClass(t) {
    this[t] ? this.link.classList.add(`ids-link--${t}`) : this.link.classList.remove(`ids-link--${t}`);
  }
  updateLinkClasses() {
    this.link.classList.add("ids-link"), this.colorpreset > 0 && (this.link.classList.contains("ids-link--color-1") && this.link.classList.remove("ids-link--color-1"), this.link.classList.contains("ids-link--color-2") && this.link.classList.remove("ids-link--color-2"), this.link.classList.contains("ids-link--color-3") && this.link.classList.remove("ids-link--color-3"), this.link.classList.add(`ids-link--color-${this.colorpreset}`)), this.activeicon && this.link.classList.add("ids-link--active-icon"), this.updateClass("light"), this.updateClass("block"), this.updateClass("active"), this.updateClass("underlined");
  }
  render() {
    return r`<slot></slot>`;
  }
}
c = new WeakMap(), h = new WeakMap(), a = new WeakMap(), u = new WeakMap(), d = new WeakMap(), p = new WeakMap(), k = new WeakMap(), v = new WeakMap(), L.styles = [i`:host{display:contents}`], t([l({
  type: Number
})], L.prototype, "colorpreset", null), t([l({
  type: Boolean,
  reflect: !0
})], L.prototype, "light", null), t([l({
  type: Boolean,
  reflect: !0
})], L.prototype, "active", null), t([l({
  type: Boolean,
  reflect: !0
})], L.prototype, "activeicon", null), t([l({
  type: Boolean,
  reflect: !0
})], L.prototype, "block", null), t([l({
  type: Boolean,
  reflect: !0
})], L.prototype, "underlined", null), t([n()], L.prototype, "isFocused", null), t([n()], L.prototype, "isHovered", null);
export { L as IDSLink };